import { useTranslation } from 'react-i18next';
import { SHIP_TYPES_COLORS } from '../../constants/_constants';
import { LegendItem } from './LegendItem';
import { Icon, Typo } from 'app/components';

import styles from './Legend.module.scss';
import clsx from 'clsx';

interface ILegend {
  isOpen?: boolean;
  onClick?: () => void;
}
export const Legend = ({ isOpen = true, onClick }: ILegend) => {
  const { t } = useTranslation();

  if (isOpen) {
    return (
      <div className={styles.legend}>
        <div className={styles.legend_header}>
          <Typo variant="span" value={`${t('ShipTypesLabel')}:`} />
          {onClick && <Icon name="close-16" size="16px" onClick={onClick} />}
        </div>
        {SHIP_TYPES_COLORS.map((item, index) => (
          <LegendItem key={index} description={t(item.type)} color={item.color} iconToShow="all" />
        ))}
        <div className={styles.legend_option}>
          <div className={styles.legend_option_title}>{`${t('DataSourceLabel')}:`}</div>
          <LegendItem description={t('SourceDescriptionSatellite')} color="#fff" iconToShow="satellite" />
          <LegendItem description={t('SourceDescriptionTerrestrial')} color="#fff" iconToShow="terrestrial" />
        </div>
        <div className={styles.legend_option}>
          <div className={styles.legend_option_title}>{`${t('Objects')}:`}</div>
          <LegendItem description={t('Port')} iconToShow="port" />
          <LegendItem description={t('PortTerminal')} iconToShow="portTerminal" />
          <LegendItem description={t('AtonDescription')} iconToShow="aton" />
        </div>

        <div className={styles.legend_option}>
          <div className={styles.legend_option_title} />
          <LegendItem description={t('LastPosition')} color="#FFFFFF" opacity="0.6" iconToShow="all" />
          <LegendItem description={t('MotionlessVessel')} iconToShow="motionless-target" />
        </div>

        <div className={styles.legend_option}>
          <div className={styles.legend_option_speed_title}>{`${t('SpeedPastTrack')}:`}</div>
          <div className={styles.legend_blocks}>
            <div className={clsx(styles.legend_block, styles.legend_label_left)}>{`< 4 ${t('VesselSpeedUnit')}`}</div>
            <div className={clsx(styles.legend_block, styles.legend_label_middle)}>{`4-8 ${t('VesselSpeedUnit')}`}</div>
            <div className={clsx(styles.legend_block, styles.legend_label_right)}>{`> 8 ${t('VesselSpeedUnit')}`}</div>
          </div>
        </div>
      </div>
    );
  } else return null;
};
